// extracted by mini-css-extract-plugin
export default {"styledForm":"PromoCodesForm_styledForm__8IZUu","label":"PromoCodesForm_label__9IWwZ punchupFormLabel"};